import { render, staticRenderFns } from "./BaseNotificationsIcon.vue?vue&type=template&id=62701d28&scoped=true&"
import script from "./BaseNotificationsIcon.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationsIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationsIcon.vue?vue&type=style&index=0&id=62701d28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62701d28",
  null
  
)

export default component.exports